import ContentLoader from 'react-content-loader';

const SalesmanModalLoader = () => {
  return (
    <ContentLoader viewBox='0 0 300 120'>
      <rect width='200' height='30' x='50' y='25' rx='4' ry='4' />
      <rect width='100' height='15' x='100' y='70' rx='3' ry='3' />
      <rect width='200' height='10' x='50' y='95' rx='3' ry='3' />
    </ContentLoader>
  );
};

export default SalesmanModalLoader;
